var map = {
	"./bash": 1799,
	"./java": 1800,
	"./json": 1801,
	"./julia": 1802,
	"./python": 1803,
	"./r": 1804,
	"./rust": 1805,
	"./scala": 1806,
	"./shell": 1807,
	"./sql": 1808,
	"./xml": 1809,
	"./yaml": 1810
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1798;